import {
  Directive, ElementRef, EventEmitter, HostBinding, HostListener,
  Input, OnChanges, OnInit, Output, SimpleChanges
} from '@angular/core';
import { JBMTableColumnAlignment, JBMTableColumnSortEvent, JBMTableColumnType }
  from './JBMTable.component';

@Directive({
  selector: '[jbm-table-column]'
})
export class ColumnDirective implements OnInit, OnChanges {
  private _sorted: boolean = false;
  private descending: boolean = false;
  private _align: JBMTableColumnAlignment;

  @Input() name: string;
  @Input() type: JBMTableColumnType;
  @Input() header: string;
  @Input() iconClassname: string;
  @Input() width: number;
  @Input() align: JBMTableColumnAlignment;
  @Input() sortable: boolean;
  @Input() sorted: boolean;
  @Input() sortdirection: string;

  @Output() sortChange = new EventEmitter<JBMTableColumnSortEvent>();

  @HostBinding('class.sortable') get isSortable() { return !!this.sortable; }
  @HostBinding('class.sorted')   get isSorted()   { return this._sorted; }
  @HostBinding('class.asc')      get isAsc()       { return this._sorted && !this.descending; }
  @HostBinding('class.desc')     get isDesc()      { return this._sorted && this.descending; }

  @HostBinding('style.width')
  get widthStyle() { return this.width ? this.width + 'rem' : 'auto'; }

  @HostBinding('style.text-align')
  get textAlign() {
    switch (this._align) {
      case JBMTableColumnAlignment.right:  return 'right';
      case JBMTableColumnAlignment.center: return 'center';
      default: return 'left';
    }
  }

  constructor(private el: ElementRef) {}

  ngOnInit() {
    if (!this.header)        this.header = '';
    if (!this.iconClassname) this.iconClassname = '';
    this.descending = this.sortdirection === '-';
    this._sorted    = !!this.sorted;
    this._align     = this.align ?? this._getAlignment();

    let html = '';
    if (this.iconClassname) html += `<i class="text-muted ${this.iconClassname}"></i>`;
    html += this.header;
    html += '<span class="resize-handle"></span>';
    this.el.nativeElement.innerHTML = html;
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.sorted)        this._sorted    = !!this.sorted;
    if (changes.sortdirection) this.descending = this.sortdirection === '-';
    if (changes.align || changes.type)
      this._align = this.align ?? this._getAlignment();
  }

  private _getAlignment(): JBMTableColumnAlignment {
    switch (this.type) {
      case JBMTableColumnType.number:
      case JBMTableColumnType.price:   return JBMTableColumnAlignment.right;
      case JBMTableColumnType.boolean: return JBMTableColumnAlignment.center;
      default:                          return JBMTableColumnAlignment.left;
    }
  }

  @HostListener('mouseup')
  onMouseUp() {
    if (!this.sortable) return;
    if (!this._sorted) {
      this._sorted   = true;
      this.descending = false;
    } else {
      this.descending = !this.descending;
    }
    this.sortChange.emit({ name: this.name, descending: this.descending });
  }
}
